<template>
  <v-card class="mx-3 my-3">
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="listadoEmpresas.data"
        :loading="listadoEmpresas.loading"
        :search="search"
        :items-per-page="10"
        :footer-props="{ itemsPerPageOptions: [10, 50, 100, 200] }"
        no-data-text="No se encontraron Empresas"
        item-key="_id"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-col class="pl-0 pt-7" sm="4" lg="3">
              <v-text-field
                v-model="search"
                placeholder="Buscar..."
                append-icon="search"
                dense
                clearable
              />
            </v-col>
            <v-col class="justify-end d-flex">
              <!-- SLOT: BOTONES -->
              <slot></slot>
            </v-col>
          </v-toolbar>
          <v-divider />
        </template>

        <template v-slot:item.descripcion_sucursal="{ item }">
          <div v-if="item.sucursales && item.sucursales.length">
            <div v-for="sucursal in item.sucursales" :key="sucursal._id">
              {{ sucursal.descripcion_sucursal }}
            </div>
          </div>
          <div v-else>Sin sucursales</div>
        </template>

        <template v-slot:item.ultima_fecha_actualizacion="{ item }">
          {{
            item.ultima_fecha_actualizacion
              ? moment(item.ultima_fecha_actualizacion).format('DD/MM/YYYY')
              : '--'
          }}
        </template>

        <template v-slot:item.esta_activo="{ item }">
          <v-btn
            small
            min-width="90"
            class="white--text"
            :color="item.esta_activo ? 'estadoActivo' : 'error'"
            @click="$emit('cambiar-estado-empresa', item)"
          >
            {{ item.esta_activo ? 'Activo' : 'Inactivo' }}
          </v-btn>
        </template>

        <template v-slot:item.muestra_empleados="{ item }">
          <v-btn
            small
            min-width="90"
            class="white--text"
            :color="item.muestra_empleados ? 'estadoActivo' : 'error'"
            @click="$emit('mostrar-empleados', item)"
          >
            {{ item.muestra_empleados ? 'Activo' : 'Inactivo' }}
          </v-btn>
        </template>

        <template v-slot:item.opciones="{ item }">
          <div class="text-no-wrap">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                  small
                  @click="
                    $router.push({
                      name: 'editarempresa',
                      params: { nit: item.nit },
                    })
                  "
                >
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  color="#1f618d"
                  v-bind="attrs"
                  v-on="on"
                  small
                  :disabled="!item.tiene_convenio"
                  @click="
                    $router.push({
                      name: 'parametrizarconvenio',
                      params: { nit: item.nit },
                    })
                  "
                >
                  add_business
                </v-icon>
              </template>
              <span>Parametrizar convenio</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  color="red"
                  v-bind="attrs"
                  v-on="on"
                  small
                  @click="$emit('eliminar-empresa', item)"
                >
                  delete_forever
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'EmpresasTable',

  props: {
    listadoEmpresas: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      search: '',
      headers: [
        { text: 'Nit', value: 'nit', align: 'center' },
        { text: 'Nombre', value: 'razon_social' },
        { text: 'Sucursales', value: 'descripcion_sucursal' },
        {
          text: 'Fecha de actualización',
          value: 'ultima_fecha_actualizacion',
          align: 'center',
        },
        {
          text: 'Estado',
          value: 'esta_activo',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Mostrar empleados',
          value: 'muestra_empleados',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Opciones',
          value: 'opciones',
          align: 'center',
          sortable: false,
        },
      ],
    };
  },
};
</script>

<style scoped></style>
